import { AlertTriangle } from "lucide-react";

export default function SyntheticBanner({ organisation }) {
  if (organisation?.is_synthetic === false) {
    return null;
  }
  const imported = String(organisation?.commercial_data_status || "").startsWith("rehearsal_imported");
  const message = imported
    ? "V1 pricing settings are loaded for checking. Review the price against V1 before sending a quote to a customer."
    : "Pricing settings have not been loaded or checked. Do not send these prices to customers.";
  return (
    <div
      data-testid="synthetic-banner"
      className="w-full bg-amber-100 border-b border-amber-300 text-amber-900 px-4 py-1.5 text-sm flex items-center gap-2 justify-center"
    >
      <AlertTriangle className="w-4 h-4" strokeWidth={2.5} />
      <span className="font-semibold">{imported ? "PRICING CHECK REQUIRED" : "TEST PRICING"}</span>
      <span className="opacity-70">|</span>
      <span className="opacity-90">{organisation?.name || "Preview organisation"} - {message}</span>
    </div>
  );
}
